import { BackIcon, Box, Button } from "@carrotfertility/carotene-core"
import { useFormContext } from "@carrotfertility/carotene-core-x"
import React from "react"
import { FormattedMessage } from "react-intl"

export function StepButtons({
  selectName,
  back,
  disabled
}: {
  selectName: string
  back: () => void
  disabled?: boolean
}): JSX.Element {
  const { watch } = useFormContext()
  const selectedValue = watch(selectName)

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBlockStart: theme.tokens.spacing.md
      })}
    >
      <Button variant="text" color="secondary" onClick={back} startIcon={<BackIcon />}>
        <FormattedMessage defaultMessage="Back" />
      </Button>

      <Button variant="outlined" color="secondary" type="submit" disabled={!selectedValue || disabled}>
        <FormattedMessage defaultMessage="Continue" />
      </Button>
    </Box>
  )
}
